import { on, selectAll, select, getAttribute } from 'modules/dom'
import { map } from 'modules/utils'

export default (el) => {
    const buttons = selectAll(".wysiwyg button.button", el)

    const buttonClick = (items) => {
        map((item) => {
            on('click', function () {
                const buttonA = select('a', item)
                if (buttonA) {
                    const src = getAttribute('href', buttonA)
                    window.open(src)
                }
            }, item)
        }, items)
    }
    buttonClick(buttons)
}
